import { useParams } from "react-router-dom";
import { ServiceProviderTemplate } from "../../../../template/service-provider/default-template";
import { ServiceProviderTabs } from "../../../../molecules/service-provider-tab";
import { ServiceProviderR } from "../../routes";
import { useFeatureFlag_EnableProductDataRemovalTasks } from "../../../../../feature-flags";
import { matchType } from "../../../../../application/domain/base/base-type";
import {
  ContentsHeader,
  PrimaryButton,
  Spinner,
} from "@graffer-inc/console-design-kit";
import { ProductDataRemovalTasksTable } from "../../../../organisms/service-provider/table/product-data-removal-task-table";
import { ProductDataRemovalTaskCreateModal } from "../../../../organisms/service-provider/modal/product-data-removal-task/product-data-removal-task-create-modal";
import { ProductDataRemovalTaskApproveModal } from "../../../../organisms/service-provider/modal/product-data-removal-task/product-data-removal-task-approve-modal";
import { ProductDataRemovalTaskCancelModal } from "../../../../organisms/service-provider/modal/product-data-removal-task/product-data-removal-task-cancel-modal";
import { useProductDataRemovalTaskModals } from "./hooks/modal-hooks";
import { useProductDataRemovalTasks } from "./hooks/main-hooks";

export const OrgProductDataRemovalTasksPage = () => {
  const { id: orgId } = useParams<{ id: string }>();
  const { modalState, handleOpenModal, handleCloseModal } =
    useProductDataRemovalTaskModals();
  const {
    orgData,
    smartApplyTasks,
    surveyTasks,
    validateCreateSmartApplyTask,
    validateCreateSurveyTask,
    createTask,
    approveTask,
    cancelTask,
    isLoading,
    isMutating,
  } = useProductDataRemovalTasks(orgId);

  // 開発中はフィーチャーフラグで表示制御する
  const ENABLE_PRODUCT_DATA_REMOVAL_TASKS =
    useFeatureFlag_EnableProductDataRemovalTasks(orgId);
  if (!ENABLE_PRODUCT_DATA_REMOVAL_TASKS) {
    return <></>;
  }

  return (
    <>
      <ServiceProviderTemplate
        breadcrumbs={[{ to: ServiceProviderR.Home.link({}), title: "Home" }]}
      >
        <ServiceProviderTabs orgId={orgId} />

        <section>
          <ContentsHeader
            title="スマート申請"
            border={false}
            buttons={[
              <PrimaryButton
                key="create-task"
                text="削除タスク登録"
                disabled={!validateCreateSmartApplyTask.valid}
                onClick={() => handleOpenModal("create", "SmartApply")}
              />,
              <p key="error-message" className="has-text-right help">
                {validateCreateSmartApplyTask.errorMessage}
              </p>,
            ]}
          >
            <ProductDataRemovalTasksTable
              tasks={smartApplyTasks}
              isLoading={isLoading}
              onApprove={(task) =>
                handleOpenModal("approve", "SmartApply", task)
              }
              onCancel={(task) => handleOpenModal("cancel", "SmartApply", task)}
            />
          </ContentsHeader>
        </section>

        <section className="mt-6">
          <ContentsHeader
            title="アンケート"
            border={false}
            buttons={[
              <PrimaryButton
                key="create-task"
                text="削除タスク登録"
                disabled={!validateCreateSurveyTask.valid}
                onClick={() => handleOpenModal("create", "Survey")}
              />,
              <p key="error-message" className="has-text-right help">
                {validateCreateSurveyTask.errorMessage}
              </p>,
            ]}
          >
            <ProductDataRemovalTasksTable
              tasks={surveyTasks}
              isLoading={isLoading}
              onApprove={(task) => handleOpenModal("approve", "Survey", task)}
              onCancel={(task) => handleOpenModal("cancel", "Survey", task)}
            />
          </ContentsHeader>
        </section>
      </ServiceProviderTemplate>

      {modalState &&
        orgData &&
        matchType(modalState.type, {
          create: (
            <ProductDataRemovalTaskCreateModal
              productCode={modalState.productCode}
              tenantSlug={orgData.slug}
              onProceed={(productCode, dueAt) => {
                createTask(productCode, dueAt);
                handleCloseModal();
              }}
              onCancel={() => handleCloseModal()}
            />
          ),
          approve: modalState.task && (
            <ProductDataRemovalTaskApproveModal
              productCode={modalState.productCode}
              tenantSlug={orgData.slug}
              task={modalState.task}
              onProceed={(task) => {
                approveTask(task);
                handleCloseModal();
              }}
              onCancel={() => handleCloseModal()}
            />
          ),
          cancel: modalState.task && (
            <ProductDataRemovalTaskCancelModal
              task={modalState.task}
              onProceed={(task) => {
                cancelTask(task);
                handleCloseModal();
              }}
              onCancel={() => handleCloseModal()}
            />
          ),
        })}

      <Spinner loading={isMutating} />
    </>
  );
};
